import { useInstanceId } from '@adsk/alloy-react-helpers';

export default (id: string | undefined) => {
  const uniqueId = useInstanceId();

  return id ?? uniqueId;
};
